import { UserShort } from '../user-short'

import type { AvatarsHost } from '@root/shared/models'

export interface SearchUser extends UserShort.UserShort {
  followersCount: number
  followingCount: number
}

export interface SearchUserDto extends UserShort.UserShortDto {
  followersCount: number
  followingCount: number
}

export const fromDto = (
  dto: SearchUserDto,
  avatarsHost: AvatarsHost,
): SearchUser => {
  return {
    ...UserShort.fromDto(dto, avatarsHost),
    followersCount: dto.followersCount,
    followingCount: dto.followingCount,
  }
}
